module.exports = __webpack_public_path__ + "img/20200905_150217.32a91588.jpg";